// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3vjHo","title":"ClientInsurance_title__3vUyn","itemText":"ClientInsurance_itemText__a-wmc"};